import * as ko from "knockout";
import {_} from 'lodash';
import {
    _d,
    decodeAndStripHtml,
    decodeHtml,
    getAnyValue,
    getTelLink,
    isNullOrUndefined,
    isSupported,
    isSupportedCircle,
    isSupportedIcon
} from "./util/misc";
import {getDate, getDateTime, getPrettyDateTime, getTime} from "./util/datetime";
import {lm} from "./appContext";
import {storeObservable} from "./util/sessionstore";
import {nsLanguage} from "./util/nsLanguage";
import {ISyncField} from "./index";

(function () {
    let existing = ko.bindingProvider.instance;

    existing = {
        nodeHasBindings: existing.nodeHasBindings,
        getBindings: function (node, bindingContext) {
            let bindings;
            try {
                bindings = existing.getBindings(node, bindingContext);
            } catch (err) {
                if (_d.log) {
                    const message = err instanceof Error ? err.message : String(err);
                    (_d.warn || _d.log)("binding error", message, node, bindingContext);
                }
            }

            return bindings ?? {};
        }
    };

})();

ko.bindingHandlers["logger"] = {
    update: function (element: HTMLElement, valueAccessor, allBindings) {
        const data = ko.toJS(valueAccessor() || allBindings());
        let observableFlag = '';
        if (ko.isObservable(valueAccessor())) {
            observableFlag = 'observable';
        }
        if (ko.isObservableArray(valueAccessor())) {
            observableFlag = 'observable array';
        }
        if (observableFlag) {
            observableFlag = `(${observableFlag})`;
        }
        _d.group('ko logger', observableFlag ?? '');
        _d.log(data);
        _d.log(element);
        _d.groupEnd();
    }
};
ko.virtualElements.allowedBindings['logger'] = true

ko.bindingHandlers["time"] = {
    update: function (element: any, valueAccessor: any, allBindingsAccessor: KnockoutAllBindingsAccessor) {
        const value = getAnyValue(valueAccessor());
        const full = getAnyValue(allBindingsAccessor())?.full ?? true
        element.innerHTML = getTime(value, full);
    }
};

ko.bindingHandlers["date"] = {
    update: function (element: any, valueAccessor: any, allBindingsAccessor: KnockoutAllBindingsAccessor) {
        const value = getAnyValue(valueAccessor());
        const full = getAnyValue(allBindingsAccessor())?.full ?? true
        element.innerHTML = getDate(value, full);
    }
};

ko.bindingHandlers["dateTime"] = {
    update: function (element: any, valueAccessor: any, allBindingsAccessor: KnockoutAllBindingsAccessor) {
        const value = getAnyValue(valueAccessor());
        const full = getAnyValue(allBindingsAccessor())?.full ?? true
        element.innerHTML = getDateTime(value, full);
    }
};

// Sibling options: full (date year), showTime, showSeconds (default false), fromNow
ko.bindingHandlers["prettyDateTime"] = {
    update: function (element: any, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor) {
        element.innerHTML = getPrettyDateTime(valueAccessor(), allBindingsAccessor())
    }
};

ko.bindingHandlers["marktext"] = {
    update: function (element, valueAccessor) {
        const obj = getAnyValue(valueAccessor());
        const key = getAnyValue(obj.key);
        const val: string = getAnyValue(obj.val);
        if (isNullOrUndefined(val)) {
            return
        }
        const strKey = String(key)
        const strVal = String(val)
        const regex = new RegExp(strKey.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi');
        const replaced = strKey
            ? strVal.replace(regex, (match) => {
                return "<mark>" + match + "</mark>";
            })
            : val;
        jQuery(element).html(replaced || val);
    }
};

ko.bindingHandlers["noempty"] = {
    update: function (element, valueAccessor, allBindingsAccessor) {
        const val = ko.unwrap(valueAccessor());
        if (val === undefined || val === null || val === "") {
            element.textContent = '—'
        } else {
            const isHtml: boolean = allBindingsAccessor().isHtml ?? false
            if (isHtml) {
                element.html = val
            } else {
                element.textContent = val
            }
        }
    }
};

ko.bindingHandlers["slideIn"] = {
    init: function (element, valueAccessor) {
        let value = ko.unwrap(valueAccessor());
        jQuery(element).toggle(value);
    },
    update: function (element, valueAccessor, allBindingsAccessor: KnockoutAllBindingsAccessor) {
        const $el = jQuery(element);
        $el.stop(true, true);
        let value = ko.utils.unwrapObservable(valueAccessor());
        const duration = ko.unwrap(allBindingsAccessor.get('duration')) ?? 200
        if (value) {
            $el.slideDown(duration);
        } else {
            $el.slideUp(duration);
        }
    }
};

ko.bindingHandlers["slideInDuration"] = {
    init: function (element, valueAccessor) {
        let obj = ko.utils.unwrapObservable(valueAccessor());
        let value = ko.utils.unwrapObservable(obj.value);
        jQuery(element).toggle(value);
    },
    update: function (element, valueAccessor) {
        jQuery(element).stop(true, true);
        let obj = ko.utils.unwrapObservable(valueAccessor());
        let value = ko.utils.unwrapObservable(obj.value);
        if (value) {
            jQuery(element).slideDown(obj.duration);
        } else {
            jQuery(element).slideUp(obj.duration);
        }
    }
};

ko.bindingHandlers["modal"] = {
    init: function (element, valueAccessor, something, viewModel) {
        jQuery(element).modal({
            show: false
        });
        let value = valueAccessor();
        if (ko.isObservable(value)) {
            jQuery(element).on('hide.bs.modal', function () {
                // a special case when using the modal-dialog component
                if (viewModel && viewModel.dialogData() && viewModel.dialogData().onClose) {
                    viewModel.dialogData().onClose();
                }
                value(false);
            });
        }
    },
    update: function (element, valueAccessor) {
        let value = valueAccessor();
        if (ko.utils.unwrapObservable(value)) {
            jQuery(element).modal('show');
        } else {
            jQuery(element).modal('hide');
        }
    }
};

ko.bindingHandlers["func"] = {
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        let fn = valueAccessor();
        if (fn) {
            fn(element, valueAccessor, allBindings, viewModel, bindingContext);
        }
    }
};

ko.bindingHandlers['cls'] = {
    'update': function (element, valueAccessor) {
        if (element['__ko__previousClassValue__']) {
            jQuery(element).removeClass(element['__ko__previousClassValue__']);
        }
        const value = ko.utils.unwrapObservable(valueAccessor());
        if (value == null || value === '') {
            element['__ko__previousClassValue__'] = '';
            return;
        }
        jQuery(element).addClass(value);
        element['__ko__previousClassValue__'] = value;
    }
};

ko.bindingHandlers['isSupportedIcon'] = {
    'update': function (element, valueAccessor) {
        element.innerHTML = isSupportedIcon(valueAccessor())
    }
};

ko.bindingHandlers['isSupported'] = {
    'update': function (element, valueAccessor) {
        element.innerHTML = isSupported(valueAccessor())
    }
};

ko.bindingHandlers['isSupportedCircle'] = {
    'update': function (element, valueAccessor, allBindingsAccessor) {
        element.innerHTML = isSupportedCircle(valueAccessor(), allBindingsAccessor().subject)
    }
};

ko.bindingHandlers['setval'] = {
    'update': function (element, valueAccessor) {
        const obj = valueAccessor();
        obj.obs(obj.val);
    }
};

interface CustomKnockoutBindingContext extends KnockoutBindingContext {
    $template?: any;
}

ko.bindingHandlers['htmlWithBinding'] = {
    'init': function (element: any, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        // this adds a $template object to the binding context to allow for easy access to the value accessor's context
        bindingContext.$template = bindingContext.$data;
        return {'controlsDescendantBindings': true};
    },
    'update': function (element: any, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        element.innerHTML = ko.utils.unwrapObservable(valueAccessor());
        ko.applyBindingsToDescendants(bindingContext, element);
    }
};

ko.bindingHandlers['local'] = {
    'update': function (element: any, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const val = getAnyValue(valueAccessor());
        element.innerHTML = nsLanguage.toLocaleString(val, {maximumFractionDigits: 1});
        ko.applyBindingsToDescendants(bindingContext, element);
    }
};

ko.bindingHandlers['phone'] = {
    'update': function (element: any, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const val = getAnyValue(valueAccessor());
        const syncfield: ISyncField = allBindingsAccessor().syncfield;
        element.innerHTML = getTelLink(val, syncfield?.name == 'Mobile' ? 'fa-mobile' : undefined);
    }
};

ko.bindingHandlers['checkedInArray'] = {
    init: function (element, valueAccessor) {
        ko.utils.registerEventHandler(element, "change", function () {
            const options = ko.utils.unwrapObservable(valueAccessor()),
                array = options.array, // don't unwrap array because we want to update the observable array itself
                value = ko.utils.unwrapObservable(options.value),
                checked = element.checked;
            const valueById = array().find((item: any) => item.id == value.id);

            // either we've found an item (to be removed) or we'll use the value
            const item = valueById || value;

            ko.utils.addOrRemoveItem(array, item, checked);
        });
    },
    update: function (element, valueAccessor) {
        const options = ko.utils.unwrapObservable(valueAccessor()),
            array = ko.utils.unwrapObservable(options.array),
            value = ko.utils.unwrapObservable(options.value);
        element.checked = !!array.find((item: any) => item.id == value.id);
    }
};

ko.bindingHandlers['noClickBubble'] = {
    init: function (element: any, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const bool = ko.unwrap(valueAccessor());
        if (bool) {
            element.addEventListener('click', (e: MouseEvent) => {
                e.stopPropagation();
            })
        }
    },
};

/**
 * Stop click bubbling only when the event originates on (or inside) an interactive control.
 * Use on expandable-row cells that mix plain text with links/buttons — empty/plain areas
 * still reach the row toggle; real controls do not.
 * Opt-out for custom widgets: `data-no-row-toggle` on the interactive root.
 */
ko.bindingHandlers['noClickBubbleOnInteractive'] = {
    init: function (element: HTMLElement, valueAccessor: () => any) {
        if (!ko.unwrap(valueAccessor())) {
            return;
        }
        const selector = 'a, button, input, textarea, select, label, [role="button"], [data-no-row-toggle]';
        element.addEventListener('click', (e: MouseEvent) => {
            const target = e.target;
            if (target instanceof Element && target.closest(selector)) {
                e.stopPropagation();
            }
        });
    },
};

ko.bindingHandlers['initBindings'] = {
    init: function (element: any, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        ko.applyBindingsToNode(element, valueAccessor(), bindingContext);
    },
};

ko.bindingHandlers['toggleDetails'] = {
    init: function (element: HTMLElement, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const obs: KnockoutObservable<boolean> = valueAccessor();
        element.addEventListener('toggle', () => {
            const isOpen = element.getAttribute('open');
            obs(isOpen !== null);
        })
    },
    update: function (element: HTMLElement, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const obs: KnockoutObservable<boolean> = valueAccessor();
        if (obs()) {
            element.setAttribute('open', 'true');
        } else {
            element.removeAttribute('open');
        }
    },
};

ko.bindingHandlers['withDomElementContext'] = {
    init: function (element: HTMLElement, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const el: HTMLElement = ko.unwrap(valueAccessor());
        const elContext = ko.contextFor(el);
        bindingContext.$component = elContext.$component;
        bindingContext.$data = elContext.$data;
        bindingContext.$parents = elContext.$parents;
        bindingContext.$parent = elContext.$parent;
        bindingContext.$parentContext = elContext.$parentContext;
    }
}

ko.bindingHandlers['replaceTag'] = {
    init: function (oldEl: HTMLElement, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const tag: keyof HTMLElementTagNameMap = ko.unwrap(valueAccessor());
        const newEl = document.createElement(tag);
        newEl.innerHTML = oldEl.innerHTML;
        const parentNode = oldEl.parentNode;
        if (!parentNode) {
            return;
        }
        parentNode.replaceChild(newEl, oldEl);
        const innerBindingContext = bindingContext.createChildContext(
            bindingContext.$rawData,
            undefined,
            function (context: CustomKnockoutBindingContext) {
                ko.utils.extend(context, {
                    $container: ko.utils.unwrapObservable(valueAccessor())
                });
            });

        ko.applyBindingsToDescendants(innerBindingContext, parentNode);
    }
}

ko.bindingHandlers['t'] = {
    update: function (element: HTMLElement, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const lang = storeObservable('language')() // trigger ko dependencies
        const obj = ko.unwrap(valueAccessor())
        if (isNullOrUndefined(obj)) {
            element.innerHTML = ''
            return
        }
        if (typeof obj === 'number') {
            element.innerHTML = nsLanguage.toLocaleString(obj)
            return
        }
        const translation = lm.t.call(lm, obj, allBindingsAccessor().p, allBindingsAccessor().onlyIfExists)
        if (typeof obj === "object" && 'fn' in obj) {
            element.innerHTML = obj.fn(translation)
            return
        }
        element.innerHTML = translation ?? ''
    },
}

// translate title
ko.bindingHandlers['tt'] = {
    update: function (element: HTMLElement, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const lang = storeObservable('language')() // trigger ko dependencies
        const obj = ko.unwrap(valueAccessor())
        if (isNullOrUndefined(obj)) {
            return
        }
        if (typeof obj === 'number') {
            element.setAttribute('title', nsLanguage.toLocaleString(obj))
            return
        }
        const translation = lm.t.call(lm, obj, _.defaultsDeep({br: false}, allBindingsAccessor().p))
        if (typeof obj === "object" && 'fn' in obj) {
            element.setAttribute('title', obj.fn(translation))
            return
        }
        element.setAttribute('title', translation ?? '')
    },
}

// translate placeholder
ko.bindingHandlers['ph'] = {
    update: function (element: HTMLElement, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const lang = storeObservable('language')() // trigger ko dependencies
        const obj = ko.unwrap(valueAccessor())
        if (isNullOrUndefined(obj)) {
            return
        }
        if (typeof obj === 'number') {
            element.setAttribute('placeholder', nsLanguage.toLocaleString(obj))
            return
        }
        const translation = lm.t.call(lm, obj, _.defaultsDeep({br: false}, allBindingsAccessor().p))
        if (typeof obj === "object" && 'fn' in obj) {
            element.setAttribute('placeholder', obj.fn(translation))
            return
        }
        element.setAttribute('placeholder', translation ?? '')
    },
}

// href attribute
ko.bindingHandlers['href'] = {
    update: function (element: HTMLElement, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
        const val = getAnyValue(valueAccessor())
        element.setAttribute('href', val)
    },
}

ko.bindingHandlers['indeterminate'] = {
    update: function (element: HTMLInputElement, valueAccessor: () => any) {
        const bool = getAnyValue(valueAccessor());
        element.indeterminate = bool
        window.requestAnimationFrame(() => element.indeterminate = bool)
    },
}

ko.bindingHandlers['execute'] = {
    update: function (element: HTMLInputElement, valueAccessor: () => (() => any)) {
        getAnyValue(valueAccessor())()
    },
}

ko.bindingHandlers['decodeHtml'] = {
    update: function (element: HTMLInputElement, valueAccessor: () => (() => any)) {
        const html = decodeHtml(String(getAnyValue(valueAccessor())))
        element.textContent = html
    },
}

ko.bindingHandlers['decodeAndStripHtml'] = {
    update: function (element: HTMLInputElement, valueAccessor: () => (() => any)) {
        const str = decodeAndStripHtml(String(getAnyValue(valueAccessor())))
        element.textContent = str
    },
}

ko.bindingHandlers['promiseToText'] = {
    update: function (element: HTMLInputElement, valueAccessor: () => Promise<string>) {
        valueAccessor()
            .then(str => {element.textContent = str})
    },
}

const fnComponentInit = function (element: any, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: CustomKnockoutBindingContext) {
    // Pass a computed so the proxy can track tab/content identity changes under soft-nav.
    // Calling native component.init on every update (old update handler) left content one click behind.
    const component: any = {
        name: 'component/component/proxy',
        params: {
            component: ko.pureComputed(() => getAnyValue(valueAccessor)),
        }
    }
    return ko.bindingHandlers.component.init?.(element, () => component, allBindingsAccessor, viewModel, bindingContext)
}

ko.bindingHandlers['_component'] = {
    init: fnComponentInit,
}

ko.virtualElements.allowedBindings['_component'] = true